__turbopack_context__.v({
  "upload-photo-dialog-actions": "upload-photo-dialog-actions-module-scss-module__mykwqq__upload-photo-dialog-actions",
  "upload-photo-dialog-actions__button-group-container": "upload-photo-dialog-actions-module-scss-module__mykwqq__upload-photo-dialog-actions__button-group-container",
  "upload-photo-dialog-actions__delete-button-container": "upload-photo-dialog-actions-module-scss-module__mykwqq__upload-photo-dialog-actions__delete-button-container",
});
